function cov_1kkyr1p2fz() {
  var path = "/app/src/types/segment.ts";
  var hash = "45a53ce2f0f91e589afaf2ef07c8392c7f9aadc9";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/types/segment.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 32
        },
        end: {
          line: 11,
          column: 10
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "45a53ce2f0f91e589afaf2ef07c8392c7f9aadc9"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1kkyr1p2fz = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1kkyr1p2fz();
export var SegmentEventType = (cov_1kkyr1p2fz().s[0]++, {
  SNIPPET_CART_RENDERED: 'Snippet Cart Rendered',
  LEARN_MORE_CLICKED: 'Learn More Clicked',
  LEARN_MORE_POP_UP_OPENED: 'Learn More Pop Up Opened',
  LEARN_MORE_POP_UP_CLOSED: 'Learn More Pop Up Closed'
});